import React, { FunctionComponent as FC, PropsWithChildren as PWC, useCallback } from 'react';

import cn from 'classnames';

import { i18n } from '../../helpers/i18n';
import { replace, SCREENS } from '../../helpers/navigation';
import Button from '../button';
import StartScreenLayout from '../start-screen-layout';
import SvgImage from '../svg-image';
import style from './start-screen-popup.css';

const closeAppIcon = <SvgImage imageName="closeApp" />;

interface Props {
    className?: string;
    blur?: boolean;
}

const MainScreenPopup: FC<Props> = ({ className, children, blur }: PWC<Props>) => {
    const onClose = useCallback(() => {
        replace(SCREENS.CREATE_CALL, {});
    }, []);
    return (
        <StartScreenLayout>
            <div className={cn(style.popup, className)}>
                <div className={style.container}>
                    <Button
                        pin="round-round"
                        view="neutral"
                        size="lg"
                        onClick={onClose}
                        className={style.closeButton}
                        icon={closeAppIcon}
                        aria-label={i18n('common', 'close-dialog')}
                    />
                    <div className={cn(style.content, { [style.content_blur]: blur })}>{children}</div>
                </div>
            </div>
        </StartScreenLayout>
    );
};

export default MainScreenPopup;
